import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LogOut } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useLogout } from '@/hooks/useLogout'
import { LogoutConfirmDialog } from '@/components/learner/LogoutConfirmDialog'

export function HeaderLogoutButton() {
  const { t } = useTranslation('learner')
  const [open, setOpen] = useState(false)
  const logout = useLogout()

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={t('auth.logout.button')}
        className={cn(
          'inline-flex items-center justify-center',
          'size-10 rounded-full bg-lc-v3-gray-50',
          'border border-lc-v3-gray-300',
          'text-lc-text-secondary hover:text-lc-text-primary hover:bg-lc-v3-gray-100',
          'transition-colors',
          'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lc-key-500',
        )}
      >
        <LogOut className="size-[18px]" />
      </button>
      <LogoutConfirmDialog
        open={open}
        onCancel={() => setOpen(false)}
        onConfirm={() => logout.mutate()}
        pending={logout.isPending}
      />
    </>
  )
}
